<template>
    <div class="page-table tabStyle mainDiv" id="affix-container">
        <el-form status-icon :model="urunForm" :rules="rulesUrun" ref="urunForm"
                 class="demo-ruleForm">
            <div>
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                        <div class="card-base card-shadow--medium padding-30">
                            <el-row>
                                <el-col :xs="24" :sm="12" :md="18" :lg="12" :xl="8" class="col-p">
                                    <div style="border : 1px solid #e6e7e8;" class="card-base kutu">
                                        <div class="kutu-baslik-svg">
                                            <svg width="100%" height="79" viewBox="120 3 97 95">
                                                <path style="stroke:none"
                                                      d="M2 19L49 19C58.0251 19 67.5385 17.9264 76 21.6806C95.7373 30.4375 99.238 53.7016 124 53.9961C145.327 54.2498 166.672 54 188 54C199.661 54 212.658 55.6103 224 52.51C240.87 47.8988 245.553 28.3828 261 21.5293C269.347 17.826 279.111 19 288 19L335 19C334.999 13.125 335.386 6.51177 329.895 2.74228C325.07 -0.570068 316.571 1 311 1L265 1L63 1L23 1C17.6184 1 10.5777 -0.221283 6.1088 3.43364C1.27106 7.39026 2 13.3935 2 19z"/>
                                            </svg>
                                            <p>Kategori</p>
                                        </div>
                                        <div class="box grow flex column justify-center">
                                            <el-form-item
                                                    prop="kategori">
                                                <el-cascader-panel ref="kategori" @change="kategoriChange"
                                                                   :options="kategoriListesi"></el-cascader-panel>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="18" :lg="12" :xl="8" class="col-p">
                                    <div style="border : 1px solid #e6e7e8;" class="card-base kutu">
                                        <div class="kutu-baslik-svg">
                                            <svg width="100%" height="79" viewBox="120 3 97 95">
                                                <path style="stroke:none;"
                                                      d="M2 19L49 19C58.0251 19 67.5385 17.9264 76 21.6806C95.7373 30.4375 99.238 53.7016 124 53.9961C145.327 54.2498 166.672 54 188 54C199.661 54 212.658 55.6103 224 52.51C240.87 47.8988 245.553 28.3828 261 21.5293C269.347 17.826 279.111 19 288 19L335 19C334.999 13.125 335.386 6.51177 329.895 2.74228C325.07 -0.570068 316.571 1 311 1L265 1L63 1L23 1C17.6184 1 10.5777 -0.221283 6.1088 3.43364C1.27106 7.39026 2 13.3935 2 19z"/>
                                            </svg>
                                            <p>Malzeme</p>
                                        </div>
                                        <div class="box grow flex column justify-center">
                                            <el-form-item prop="malzeme">
                                                <el-cascader-panel ref="malzeme" @change="malzemeChange"
                                                                   :options="malzemeList"></el-cascader-panel>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="18" :lg="12" :xl="8" class="col-p resim">
                                    <div style="border : 1px solid #e6e7e8;" class="card-base kutu">
                                        <div class="kutu-baslik-svg">
                                            <svg width="100%" height="79" viewBox="120 3 97 95">
                                                <path style="stroke:none;"
                                                      d="M2 19L49 19C58.0251 19 67.5385 17.9264 76 21.6806C95.7373 30.4375 99.238 53.7016 124 53.9961C145.327 54.2498 166.672 54 188 54C199.661 54 212.658 55.6103 224 52.51C240.87 47.8988 245.553 28.3828 261 21.5293C269.347 17.826 279.111 19 288 19L335 19C334.999 13.125 335.386 6.51177 329.895 2.74228C325.07 -0.570068 316.571 1 311 1L265 1L63 1L23 1C17.6184 1 10.5777 -0.221283 6.1088 3.43364C1.27106 7.39026 2 13.3935 2 19z"/>
                                            </svg>
                                            <p>Resim</p>
                                        </div>
                                        <div class="box grow flex column justify-center">
                                            <el-form-item ref="resim" prop="image" style="height: 133px">
                                                <el-upload
                                                        action=""
                                                        :auto-upload="false"
                                                        :limit="1"
                                                        accept=".jpg,.jpeg,.png"
                                                        ref="upload"
                                                        list-type="picture-card"
                                                        :on-change="imageUpload"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="24" class="col-p">
                                    <el-row>
                                        <el-col :xs="24" :sm="12" :md="12" :lg="24" :xl="8" class="col-p kucuk_kutu">
                                            <div style="border : 1px solid #e6e7e8;"
                                                 class="card-base kutu margin-top-20">
                                                <div class="kutu-baslik-svg">
                                                    <svg width="100%" height="79" viewBox="120 3 97 95">
                                                        <path style="stroke:none;"
                                                              d="M2 19L49 19C58.0251 19 67.5385 17.9264 76 21.6806C95.7373 30.4375 99.238 53.7016 124 53.9961C145.327 54.2498 166.672 54 188 54C199.661 54 212.658 55.6103 224 52.51C240.87 47.8988 245.553 28.3828 261 21.5293C269.347 17.826 279.111 19 288 19L335 19C334.999 13.125 335.386 6.51177 329.895 2.74228C325.07 -0.570068 316.571 1 311 1L265 1L63 1L23 1C17.6184 1 10.5777 -0.221283 6.1088 3.43364C1.27106 7.39026 2 13.3935 2 19z"/>
                                                    </svg>
                                                    <p>Estaş Kodu</p>
                                                </div>
                                                <div class="box grow flex column justify-center padding-10">
                                                    <el-input ref="estasKodu"
                                                              @focus="addClasss('estasKodu')"
                                                              size="small" v-on:blur="estasKodKontrol"
                                                              v-model="urunForm.estasKodu"
                                                              placeholder="EST-"></el-input>
                                                </div>
                                            </div>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :md="12" :lg="24" :xl="8" class="col-p kucuk_kutu">
                                            <div style="border : 1px solid #e6e7e8;"
                                                 class="card-base kutu margin-top-30">
                                                <div class="kutu-baslik-svg">
                                                    <svg width="100%" height="79" viewBox="120 3 97 95">
                                                        <path style="stroke:none;"
                                                              d="M2 19L49 19C58.0251 19 67.5385 17.9264 76 21.6806C95.7373 30.4375 99.238 53.7016 124 53.9961C145.327 54.2498 166.672 54 188 54C199.661 54 212.658 55.6103 224 52.51C240.87 47.8988 245.553 28.3828 261 21.5293C269.347 17.826 279.111 19 288 19L335 19C334.999 13.125 335.386 6.51177 329.895 2.74228C325.07 -0.570068 316.571 1 311 1L265 1L63 1L23 1C17.6184 1 10.5777 -0.221283 6.1088 3.43364C1.27106 7.39026 2 13.3935 2 19z"/>
                                                    </svg>
                                                    <p>Ürün Adı</p>
                                                </div>
                                                <div class="box grow flex column justify-center padding-10">
                                                    <el-input
                                                            ref="urunAdi"
                                                            @focus="addClasss('urunAdi')"
                                                            @blur="removeClasss('urunAdi')"
                                                            size="small"
                                                            v-model="urunForm.urunAdi"
                                                            :placeholder='$t("src.views.apps.urun.tanimlama.urunAdiPlace")'></el-input>
                                                </div>
                                            </div>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :md="12" :lg="24" :xl="8" class="col-p kucuk_kutu">
                                            <div style="border : 1px solid #e6e7e8;"
                                                 class="card-base kutu margin-top-30">
                                                <div class="kutu-baslik-svg">
                                                    <svg width="100%" height="79" viewBox="120 3 97 95">
                                                        <path style="stroke:none;"
                                                              d="M2 19L49 19C58.0251 19 67.5385 17.9264 76 21.6806C95.7373 30.4375 99.238 53.7016 124 53.9961C145.327 54.2498 166.672 54 188 54C199.661 54 212.658 55.6103 224 52.51C240.87 47.8988 245.553 28.3828 261 21.5293C269.347 17.826 279.111 19 288 19L335 19C334.999 13.125 335.386 6.51177 329.895 2.74228C325.07 -0.570068 316.571 1 311 1L265 1L63 1L23 1C17.6184 1 10.5777 -0.221283 6.1088 3.43364C1.27106 7.39026 2 13.3935 2 19z"/>
                                                    </svg>
                                                    <p>Ürün Adı</p>
                                                </div>
                                                <div class="box grow flex column justify-center padding-10">
                                                    <el-input
                                                            ref="urunAdiEN"
                                                            @focus="addClasss('urunAdiEN')"
                                                            @blur="removeClasss('urunAdiEN')"
                                                            size="small"
                                                            v-model="urunForm.urunAdiEN"
                                                            :placeholder='$t("src.views.apps.urun.tanimlama.urunAdiENPlace")'></el-input>
                                                </div>
                                            </div>
                                        </el-col>
                                        <!--<el-col :xs="12" :sm="12" :md="12" :lg="24" :xl="24" class="col-p kucuk_kutu">-->
                                            <!--<el-switch-->
                                                    <!--class="margin-top-30"-->
                                                    <!--v-model="urunForm.katalog"-->
                                                    <!--active-color="#13ce66"-->
                                                    <!--inactive-color="#ff4949"-->
                                                    <!--active-text="Katalogda Görünsün"-->
                                                    <!--inactive-text="Katalogda Görünmesin"-->
                                                    <!--active-value="1"-->
                                                    <!--inactive-value="0">-->
                                            <!--</el-switch>-->
                                        <!--</el-col>-->
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-button class="margin-top-20 margin-bottom-20" size="mini"
                                       v-on:click="parcaOzellik()">
                                Seçenek Tanımla
                            </el-button>
                        </div>
                    </el-col>
                    <!--<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">-->
                        <!--<div v-if="parcaVisible" class="card-base card-shadow&#45;&#45;medium padding-30 animated fadeInLeft">-->
                            <!--<mil-formu :urunDetay="urunDetay"></mil-formu>-->
                        <!--</div>-->
                    <!--</el-col>-->
                </el-row>
            </div>
            <div v-if="parcaVisible"
                 class="card-base card-shadow--medium demo-box bg-white margin-top-10 animated fadeInLeft">
                <div class="margin-top-10 pl-20 pr-20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6">
                            <div class="card-base kutu margin-top-10">
                                <div class="kutu-baslik-svg">
                                    <svg width="100%" height="79" viewBox="120 3 97 60">
                                        <path style="stroke:none;"
                                              d="M2 19L49 19C58.0251 19 67.5385 17.9264 76 21.6806C95.7373 30.4375 99.238 53.7016 124 53.9961C145.327 54.2498 166.672 54 188 54C199.661 54 212.658 55.6103 224 52.51C240.87 47.8988 245.553 28.3828 261 21.5293C269.347 17.826 279.111 19 288 19L335 19C334.999 13.125 335.386 6.51177 329.895 2.74228C325.07 -0.570068 316.571 1 311 1L265 1L63 1L23 1C17.6184 1 10.5777 -0.221283 6.1088 3.43364C1.27106 7.39026 2 13.3935 2 19z"/>
                                    </svg>
                                    <p>Parça No
                                        <i class="el-icon-arrow-down"></i>
                                    </p>
                                </div>
                                <div class="box grow flex column justify-center padding-20">
                                    <el-form-item
                                            prop="parcaKodu">
                                        <el-row :gutter="10">
                                            <el-input id="parcaKodu" ref="parcaKodu" @focus="addClasss('parcaKodu')"
                                                      @blur="removeClasss('parcaKodu')" size="small"
                                                      v-model="urunForm.parcaKodu"></el-input>
                                        </el-row>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                        <el-col v-for="(detay,index) in kategoriOpsListesi"
                                v-bind:key="index" :xs="24" :sm="12" :md="8" :lg="8" :xl="6">
                            <div class="card-base kutu margin-top-10">
                                <div class="kutu-baslik-svg">
                                    <svg width="100%" height="79" viewBox="120 3 97 60">
                                        <path style="stroke:none;"
                                              d="M2 19L49 19C58.0251 19 67.5385 17.9264 76 21.6806C95.7373 30.4375 99.238 53.7016 124 53.9961C145.327 54.2498 166.672 54 188 54C199.661 54 212.658 55.6103 224 52.51C240.87 47.8988 245.553 28.3828 261 21.5293C269.347 17.826 279.111 19 288 19L335 19C334.999 13.125 335.386 6.51177 329.895 2.74228C325.07 -0.570068 316.571 1 311 1L265 1L63 1L23 1C17.6184 1 10.5777 -0.221283 6.1088 3.43364C1.27106 7.39026 2 13.3935 2 19z"/>
                                    </svg>
                                    <p>{{detay.baslik}}
                                        <i class="el-icon-arrow-down"></i>
                                    </p>
                                </div>
                                <div class="box grow flex column justify-center padding-20">
                                    <el-form-item :prop="detay.uOpsiyonKodu">
                                        <el-row :gutter="10">
                                            <el-col :xs="24" :sm="24" :md="14" :lg="20" :xl="20">
                                                <el-switch
                                                        v-if="detay.cevapTipi === '1'"
                                                        v-model="opsiyonForm.model[index]"
                                                        active-value="1"
                                                        inactive-value="0"
                                                        active-text="Evet"
                                                        inactive-text="Hayır">
                                                </el-switch>
                                                <el-input size="small" style="width: 100%"
                                                          v-model="opsiyonForm.model[index]"
                                                          v-if="detay.cevapTipi === '2'"></el-input>
                                                <el-select
                                                        :ref="detay.baslik"
                                                        @focus="addClasss(detay.baslik)"
                                                        @blur="removeClasss(detay.baslik)"
                                                        :placeholder="'Lütfen '+detay.baslik+' seçiniz.'"
                                                        :no-match-text="detay.baslik"
                                                        filterable
                                                        size="small"
                                                        style="width: 100%"
                                                        v-model="opsiyonForm.model[index]"
                                                        v-if="detay.cevapTipi === '3' && detay.uOpsiyonKodu !== 'OP-55000' && detay.uOpsiyonKodu !== 'OP-55001'">
                                                    <el-option
                                                            v-for="item in detay.secenekList"
                                                            :key="item.secenekKodu"
                                                            :label="item.secenekAdi"
                                                            :value="item.secenekKodu">
                                                    </el-option>
                                                </el-select>
                                                <el-select
                                                        :ref="detay.baslik"
                                                        @focus="addClasss(detay.baslik)"
                                                        @blur="removeClasss(detay.baslik)"
                                                        filterable
                                                        :no-match-text="detay.baslik"
                                                        size="small"
                                                        v-on:change="getAracModelListesi"
                                                        style="width: 100%"
                                                        v-model="opsiyonForm.model[index]"
                                                        v-if="detay.cevapTipi === '3' && detay.uOpsiyonKodu === 'OP-55000'">
                                                    <el-option
                                                            v-for="item in detay.secenekList"
                                                            :key="item.secenekKodu"
                                                            :label="item.secenekAdi"
                                                            :value="item.secenekKodu">
                                                    </el-option>
                                                </el-select>
                                                <el-select
                                                        :ref="detay.baslik"
                                                        @focus="addClasss(detay.baslik)"
                                                        @blur="removeClasss(detay.baslik)"
                                                        filterable
                                                        :no-match-text="detay.baslik"
                                                        size="small"
                                                        v-if="detay.cevapTipi === '3' && detay.uOpsiyonKodu === 'OP-55001'"
                                                        v-model="opsiyonForm.model[index]"
                                                        style="width: 100%">
                                                    <el-option
                                                            v-for="item in detay.secenekList"
                                                            :key="item.secenekKodu"
                                                            :label="item.secenekAdi"
                                                            :value="item.secenekKodu">
                                                    </el-option>
                                                </el-select>
                                                <el-checkbox
                                                        v-model="opsiyonForm.model[index]"
                                                        v-if="detay.cevapTipi === '4'"
                                                        v-for="item in detay.secenekList"
                                                        :key="item.secenekKodu"
                                                        :label="item.secenekAdi"
                                                        :value="item.secenekKodu"></el-checkbox>
                                                <el-radio
                                                        v-model="opsiyonForm.model[index]"
                                                        v-if="detay.cevapTipi === '5'"
                                                        v-for="item in detay.secenekList"
                                                        :key="item.secenekKodu"
                                                        :label="item.secenekAdi"
                                                        :value="item.secenekKodu"></el-radio>
                                                <el-date-picker
                                                        size="small"
                                                        v-if="detay.cevapTipi === '6'"
                                                        style="width: 100%"
                                                        v-model="opsiyonForm.model[index]"
                                                        type="monthrange"
                                                        range-separator=" - "
                                                        start-placeholder="Başlangıç"
                                                        end-placeholder="Bitiş"
                                                        value-format="MM/yyyy"
                                                        format="MM/yyyy">
                                                </el-date-picker>
                                                <el-time-picker
                                                        size="small"
                                                        style="width: 100%"
                                                        v-model="opsiyonForm.model[index]"
                                                        v-if="detay.cevapTipi === '7'"
                                                        :picker-options="{
                                                              selectableRange: '18:30:00 - 20:30:00'}"
                                                        placeholder="Saat Seçiniz">
                                                </el-time-picker>
                                                <el-input
                                                        size="small"
                                                        type="textarea"
                                                        style="width: 100%"
                                                        v-model="opsiyonForm.model[index]"
                                                        v-if="detay.cevapTipi === '8'">
                                                </el-input>
                                            </el-col>
                                            <el-col :xs="24" :sm="24" :md="10" :lg="4" :xl="4">
                                                <el-button v-if="detay.tablo !== null" size="mini" plain type="warning"
                                                           icon="mdi mdi-plus"
                                                           v-on:click="opsiyonEkle(detay.baslik)"></el-button>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <div style="padding:10px 0 20px 0">
                        <el-button size="mini" type="info" icon="el-icon-plus" plain
                                   v-on:click="parcaEkle('1')">Ekle
                        </el-button>
                        <el-button id="click" size="mini" type="success" icon="el-icon-plus" plain
                                   v-on:click="parcaEkle('2')">
                            Ekle -
                            Parça No Sıfırla
                        </el-button>
                        <el-button size="mini" type="primary" icon="el-icon-plus" plain
                                   v-on:click="parcaEkle('3')">Ekle -
                            Marka Sıfırla
                        </el-button>
                    </div>
                </div>
            </div>
            <div v-if="tabloVisible"
                 class="card-base card-shadow--medium demo-box bg-white margin-top-10 margin-bottom-50 animated fadeInLeft">
                <el-row :gutter="10" class="pr-20 pl-20">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24" v-for="item in parcaTablo" :key="item.parcaKodu">
                        <div class="parca-baslik">{{item.parcaKodu}}</div>
                        <div v-for="item1 in item.parcaDetay" :key="item1.baslik">
                            <div class="flex">
                                <div class="parca-listesi flex wrap">
                                    <div class="parca-item" v-for="item2 in item1" :key="item2.value">
                                        <div>{{item2.label}}</div>
                                        <div class="aracizik"></div>
                                        <div>{{item2.value}}</div>
                                    </div>
                                </div>
                                <div class="gokhanMargarin">
                                    <el-button v-on:click="duzenle(item,item1)" type="primary" size="mini" plain
                                               icon="mdi mdi-file-document-edit"></el-button>
                                    <el-button v-on:click="sil(item,item1)" :data-rndKey="item1[0].rndKey" type="danger"
                                               size="mini" plain
                                               icon="mdi mdi-close"></el-button>
                                </div>
                            </div>
                            <div class="altcizik"></div>
                        </div>
                    </el-col>
                </el-row>
                <el-button style="float: right; margin: 10px 30px" size="mini" type="primary" icon="el-icon-folder"
                           plain v-on:click="kaydet">Kaydet
                </el-button>
            </div>
        </el-form>
        <opsiyon-ekleme v-if="dialogVisibleOpsiyon" :dialogvisible.sync="dialogVisibleOpsiyon"
                        :opsiyon="opsiyon"></opsiyon-ekleme>
    </div>
</template>
<script>
    import JQuery from 'jquery';
    import urunService from '../../../WSProvider/UrunService'
    import opsiyonService from '../../../WSProvider/OpsiyonService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'
    import OpsiyonEkleme from '@/components/OpsiyonEkleme'
    import milFormu from '@/components/MilFormu'
    import EventBus from '@/components/event-bus'

    let $ = JQuery;
    export default {
        name: "UrunTanimla",
        components: {
            OpsiyonEkleme,
            milFormu,
        },
        // watch: {
        //     dialogVisibleOpsiyon: function (val) {
        //         if (val === false) {
        //             this.opsiyonRefresh(this.opsiyonAdi);
        //         }
        //     }
        // },
        mounted() {
            this.getKategoriListesi();
            this.getMalzemeListesi();

            let self = this;
            EventBus.$on('opsiyonList', function (bool) {
                if (bool) {
                    self.getKategoriOpsiyonListesi();

                }
            });
        },
        data() {
            return {
                baslikKontrol: '',
                opsiyonAdi: '',
                arac : '',
                dialogVisibleOpsiyon: false,
                opsiyon: {},
                urunDetay: {},
                parcaVisible: false,
                tabloVisible: false,
                parcaTablo: [],
                parcaKodList: [],
                parcaKodList1: [],
                size: 0,
                malzemeList: [],
                kategoriListesi: [],
                kategoriOpsListesi: [],
                urunForm: {
                    kategori: '',
                    kategoriAdi: '',
                    urunAdi: '',
                    katalog: 1,
                    yasamDurumu: 1,
                    urunAdiEN: '',
                    estasKodu: 'EST ',
                    parcaKodu: '',
                    malzeme: '',
                    malzemeAdi: '',
                    image: '',
                    imageBase: '',
                    parcaList: []
                },
                opsiyonForm: {
                    model: []
                },
                rulesUrun: {
                    urunAdi: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    estasKodu: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    kategori: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    parcaKodu: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            duzenle(item, item1) {
                let self = this;
                self.opsiyonForm.model = [];
                self.kategoriOpsListesi.forEach(function (e, i) {
                    item1.forEach(function (d, y) {
                        if (self.kategoriOpsListesi[i].baslik === item1[y].label) {
                            if (item1[y].kod) {
                                self.opsiyonForm.model[i] = item1[y].kod
                            } else self.opsiyonForm.model[i] = item1[y].value
                        }
                    })
                });
                self.urunForm.parcaKodu = item.parcaKodu;
            },
            sil(item, item1) {
                let self = this;
                this.parcaTablo.forEach(function (e, i) {
                    if (e.parcaKodu === item.parcaKodu) {
                        e.parcaDetay.forEach(function (d, k) {
                            if (d[0].rndKey === item1[0].rndKey) {
                                e.parcaDetay.splice(k, 1);
                            }
                        });
                        if (e.parcaDetay.length === 0) {
                            self.parcaTablo.splice(i, 1);
                        }
                    }
                });
                if (this.parcaTablo.length === 0) {
                    this.tabloVisible = false;
                }
            },
            parcaOzellik() {
                this.urunDetay = this.urunForm;
                this.$refs.urunForm.validate((valid) => {
                    if (valid) {
                        this.parcaVisible = true
                    } else {
                        notification.Status('warning', this, 'Doldurulması zorunlu olan alanları gözden geçiriniz!!');
                        return false;
                    }
                });
            },
            kaydet() {
                var dil = [];
                this.parcaTablo.forEach(function (e, i) {
                    e.parcaDetay.forEach(function (a, k) {
                        a.forEach(function (m, j) {
                            delete m['kod'];
                            delete m['label'];
                            delete m['value'];
                            delete m['rndKey'];
                        });
                    })
                });
                dil = {
                    en: {
                        urunAdi: this.urunForm.urunAdiEN
                    }
                };
                console.log(this.parcaTablo)
                urunService.urunTanimlama(this.urunForm.kategori, this.urunForm.estasKodu, this.urunForm.urunAdi, this.urunForm.image, this.urunForm.malzeme, this.urunForm.malzemeAdi, 1, this.urunForm.katalog, this.parcaTablo, dil, 1).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Ürün başarıyla eklendi.');
                        this.parcaTablo = [];
                        this.tabloVisible = false;
                        this.parcaVisible = false;
                    } else notification.Status(response.status, this)
                })
            },
            parcaEkle(durum) {
                this.$refs.urunForm.validate((valid) => {
                    if (valid) {
                        var dizi = [];
                        var dizi2 = [];
                        let self = this;
                        this.opsiyonForm.model.forEach(function (e, i) {
                            if (self.kategoriOpsListesi[i].secenekList !== undefined) {
                                let obj = self.kategoriOpsListesi[i].secenekList.find(data => data.secenekKodu === self.opsiyonForm.model[i]);
                                var item2 = {
                                    opsiyonKodu: self.kategoriOpsListesi[i].uOpsiyonKodu,
                                    cevapKodu: self.opsiyonForm.model[i],
                                    cevap: obj.secenekAdi,
                                    aciklama: '',
                                    label: self.kategoriOpsListesi[i].baslik,
                                    value: obj.secenekAdi,
                                    kod: obj.secenekKodu,
                                    rndKey: randomTextOps(5)
                                };
                                dizi["ParcaNo"] = self.urunForm.parcaKodu
                                dizi[self.kategoriOpsListesi[i].baslik] = obj.secenekAdi;
                                dizi2.push(item2);

                            } else {
                                if(self.opsiyonForm.model[i].__proto__.push){
                                    item2 = {
                                        opsiyonKodu: self.kategoriOpsListesi[i].uOpsiyonKodu,
                                        cevapKodu: '',
                                        cevap: self.opsiyonForm.model[i][0] + " - " + self.opsiyonForm.model[i][1] ,
                                        aciklama: '',
                                        label: self.kategoriOpsListesi[i].baslik,
                                        value: self.opsiyonForm.model[i],
                                        rndKey: randomTextOps(5)
                                    };
                                }else{
                                    item2 = {
                                        opsiyonKodu: self.kategoriOpsListesi[i].uOpsiyonKodu,
                                        cevapKodu: '',
                                        cevap: self.opsiyonForm.model[i],
                                        aciklama: '',
                                        label: self.kategoriOpsListesi[i].baslik,
                                        value: self.opsiyonForm.model[i],
                                        rndKey: randomTextOps(5)
                                    };
                                }
                                dizi["ParcaNo"] = self.urunForm.parcaKodu
                                dizi[self.kategoriOpsListesi[i].baslik] = self.opsiyonForm.model[i];
                                dizi2.push(item2);
                            }
                        });
                        let obj1 = self.parcaTablo.find(data => data.parcaKodu === self.urunForm.parcaKodu);
                        if (obj1 === undefined) {
                            self.parcaKodList1 = [];
                            self.parcaKodList1.push(dizi2);
                            self.parcaTablo.push({
                                parcaKodu: this.urunForm.parcaKodu,
                                parcaDetay: self.parcaKodList1
                            });
                        } else {
                            obj1.parcaDetay.push(dizi2);
                        }
                        this.urunForm.parcaList.push(dizi);
                        self.urunDetay = self.urunForm;
                        self.tabloVisible = true;
                        switch (durum) {
                            case '1' :
                                self.urunForm.parcaKodu = "";
                                $(self.$refs["parcaKodu"].$el).closest(".card-base").find(".kutu-baslik-svg").removeClass("parcaKodu");
                                self.opsiyonForm.model = [];
                                notification.Status('success', this, 'Ürün Oluşturuldu.');
                                break;
                            case '2' :
                                self.urunForm.parcaKodu = "";
                                $(self.$refs["parcaKodu"].$el).closest(".card-base").find(".kutu-baslik-svg").addClass("parcaKodu");
                                notification.Status('success', this, 'Ürün Oluşturuldu.');
                                // $('#affix-container').animate({
                                //     scrollTop: $("#parcaKodu").offset().top
                                // }, 2000);
                                break;
                            case '3' :
                                self.kategoriOpsListesi.forEach(function (e, i) {
                                    if (self.kategoriOpsListesi[i].uOpsiyonKodu === 'OP-55000' || self.kategoriOpsListesi[i].uOpsiyonKodu === 'OP-55001') {
                                        self.opsiyonForm.model[i] = "";
                                    }
                                });
                                notification.Status('success', this, 'Ürün Oluşturuldu.');
                                break;

                        }

                    } else {
                        notification.Status('warning', this, 'Doldurulması zorunlu olan alanları gözden geçiriniz!!');
                        return false;
                    }
                });

            },
            getKategoriListesi() {
                let self = this;
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                label: e.kategoriAdi,
                                value: e.ukategoriKodu
                            };
                            self.kategoriListesi.push(item);
                        });
                    } else notification.Status(response.status, this)
                })
            },
            addClasss(refs) {
                let self = this;
                if (this.$refs[refs].length === 1) {
                    $(this.$refs[refs][0].$el).closest(".card-base").find(".kutu-baslik-svg").addClass("aktif");
                }
                $(this.$refs[refs].$el).closest(".card-base").find(".kutu-baslik-svg").addClass("aktif");
            },
            removeClasss(refs) {
                if (this.$refs[refs].length === 1) {
                    $(this.$refs[refs][0].$el).closest(".card-base").find(".kutu-baslik-svg").removeClass("aktif");
                    $(this.$refs[refs][0].$el).closest(".card-base").find(".kutu-baslik-svg").removeClass("tamamlanmis");
                    if (this.$refs[refs][0]) {
                        $(this.$refs[refs][0].$el).closest(".card-base").find(".kutu-baslik-svg").addClass("tamamlanmis");
                    }
                }
                $(this.$refs[refs].$el).closest(".card-base").find(".kutu-baslik-svg").removeClass("aktif");
                $(this.$refs[refs].$el).closest(".card-base").find(".kutu-baslik-svg").removeClass("tamamlanmis");
                if (this.urunForm[refs]) {
                    $(this.$refs[refs].$el).closest(".card-base").find(".kutu-baslik-svg").addClass("tamamlanmis");
                }
            },
            kategoriChange(value) {
                let self = this;
                $(this.$refs.kategori.$el).closest(".card-base").find(".kutu-baslik-svg").addClass("aktif");
                value.forEach(function (e) {
                    self.urunForm.kategori = e;
                });
                let obj = self.kategoriListesi.find(data => data.value === self.urunForm.kategori);
                self.urunForm.kategoriAdi = obj.label;
                this.getKategoriOpsiyonListesi();
            },
            malzemeChange(value) {
                let self = this;
                $(this.$refs.malzeme.$el).closest(".card-base").find(".kutu-baslik-svg").addClass("aktif");
                value.forEach(function (e) {
                    self.urunForm.malzeme = e;
                });
                let obj = self.malzemeList.find(data => data.value === self.urunForm.malzeme);
                self.urunForm.malzemeAdi = obj.label;
            },
            getKategoriOpsiyonListesi() {
                // this.kategoriOpsListesi = [];
                urunService.kategoriOpsiyonList(this.urunForm.kategori).then((response) => {
                    if (response.status === 200) {
                        this.kategoriOpsListesi = response.data;
                        this.getAracModelListesi(this.arac);
                    } else notification.Status(response.status, this)
                })
            },
            getMalzemeListesi() {
                let self = this;
                urunService.malzemeListesi().then((response) => {
                    if (response.status === 200) {
                        if (response.data.length > 0) {
                            this.urunForm.malzeme = response.data[0].malzemeKodu
                        }
                        response.data.forEach(function (e) {
                            var item = {
                                label: e.malzeme,
                                value: e.malzemeKodu
                            };
                            self.malzemeList.push(item);
                        })

                    } else notification.Status(response.status, this)
                })
            },
            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                $(this.$refs.resim.$el).closest(".card-base").find(".kutu-baslik-svg").addClass("aktif");
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.urunForm.urunAdi) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "urun-" +  randomText(7) + '-' + linkTemizle(this.urunForm.urunAdi) + ".jpg";
                        } else {
                            imgname = "urun-" + randomText(7) + '-' + linkTemizle(this.urunForm.urunAdi) + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "urun-" + randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "urun-" + randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    this.sumResimFonk(file, imgname);
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        this.urunForm.imageBase = data;
                        controllerService.resimYukle('urun', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.urunForm.image = imgname;
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageRemove() {
                $(this.$refs.resim.$el).closest(".card-base").find(".kutu-baslik-svg").removeClass("aktif");
                $('.el-upload--picture-card').show();
            },
            getAracModelListesi(value) {
                if(value){
                    this.arac = value;
                }
                this.$store.commit('changeMarkaKodu', this.arac);
                let self = this;
                opsiyonService.modelList(value, '1', '', '').then((response) => {
                    if (response.status === 200) {
                        self.kategoriOpsListesi.forEach(function (e, i) {
                            if (self.kategoriOpsListesi[i].uOpsiyonKodu === 'OP-55001') {
                                if (response.data.length > 0) {
                                    var tumu = {
                                        modelAdi: "TÜMÜ",
                                        modelKodu: "0"
                                    };
                                    self.kategoriOpsListesi[i].secenekList = [];
                                    response.data.unshift(tumu);
                                    response.data.forEach(function (d) {
                                        self.kategoriOpsListesi[i].secenekList.push({
                                            secenekAdi: d.modelAdi,
                                            secenekKodu: d.modelKodu
                                        })
                                    });
                                    self.opsiyonForm.model[i] = response.data[0].modelKodu;
                                } else {
                                    self.kategoriOpsListesi[i].secenekList = [];
                                    self.opsiyonForm.model[i] = "";
                                }
                            }
                        });
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            opsiyonEkle(baslik) {
                var opsiyon = linkTemizle(baslik.replace(" ", ""));
                this.opsiyon = opsiyon;
                this.dialogVisibleOpsiyon = true;
                this.opsiyonAdi = baslik;
            },
            opsiyonRefresh(baslik) {

                let self = this;  console.log(self.kategoriOpsListesi)

                self.kategoriOpsListesi.forEach(function (e, i) {
                    if (self.kategoriOpsListesi[i].baslik === baslik && self.$store.state.opsiyonList.length !== 0) {
                        self.kategoriOpsListesi[i].secenekList = self.$store.state.opsiyonList;
                    }
                });
            },
            estasKodKontrol() {
                let self = this;
                this.removeClasss('estasKodu');
                urunService.urunKontrol(this.urunForm.estasKodu).then((response) => {
                    if (response.status === 200) {
                        this.parcaVisible = true
                        this.tabloVisible = true;
                        notification.Status('warning', this, 'Bu bilgiler ile bir ürün kayıtlı');
                    }
                })
            },

        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')


    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }

    function randomTextOps(length) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    }

</script>
<style scoped>
</style>
<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

    .parca-baslik {
        background: #1c2d56;
        background: -webkit-gradient(linear, left top, right top, from(#1c2d56), color-stop(20%, #1c2d56), to(transparent));
        background: linear-gradient(to right, #1c2d56, #1c2d56 20%, transparent);
        color: #fff;
        font-size: 18px !important;
        font-weight: 500;
        padding: 5px 10px;
        border-radius: 5px;
    }

    .parca-item {
        padding: 10px;
        text-align: center;
        position: relative;
        width: 10%;
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .parca-item:before {
        content: "";
        position: absolute;
        width: 1px;
        height: 100%;
        background: linear-gradient(to bottom, transparent, #5f98d4ad, transparent);
        right: 0;
        top: 0;
    }

    .parca-item div:first-child {
        font-weight: 600;
        margin-bottom: 5px;
    }

    .altcizik {
        border-bottom: 1px solid #ddd;
        margin: 15px 0;
        padding: 0 10px;
    }

    .gokhanMargarin {
        width: 10%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .parca-listesi {
        width: 90%;
    }

    @media (max-width: 1919px) {
        .resim {
            padding: 20px;
        }
    }

    @media screen and (max-width: 1366px) {
        .kucuk_kutu {
            padding: 0 !important;
        }
    }


    .baglanti .el-upload--picture-card {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        display: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        cursor: pointer;
        line-height: 146px;
        vertical-align: top;
    }
    .el-upload-list--picture-card {
        margin: 0;
        display: inline;
        vertical-align: top;
        padding: 5px;
    }
    .baglanti {
        .el-upload-list--picture-card .el-upload-list__item {
            overflow: hidden;
            background-color: #fff;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 150px !important;
            height: 160px !important;
            margin: 0 8px 8px 0;
            display: inline-block;
        }

        .imgNameDiv {
            margin: 0 10px;
            text-align: center;
            font-size: 10px !important;
            vertical-align: middle;
        }
    }
    .baglantiBtn i {
        font-size: 28px;
        color: #8c939d;
    }

    .el-upload-list--picture-card .el-upload-list__item-thumbnail {
        width: 100%;
        height: 100%;
        min-height: 111px !important;
    }
    .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
        margin-top: 60px;
    }
    .kutu .el-upload--picture-card {
        position: absolute;
        left: calc(50% - 100px);
        background-color: #e6e7e8;
        border: none;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 200px;
        height: 148px;
        cursor: pointer;
        line-height: 146px;
        vertical-align: top;
    }
    .kutu .el-upload--picture-card {
        position: absolute;
        left: calc(50% - 100px);
        background-color: #ffffff !important;
        border: none;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 200px;
        height: 148px;
        cursor: pointer;
        line-height: 146px;
        vertical-align: top;
    }
    .el-upload-list--picture-card .el-upload-list__item {
        position: absolute;
        left: calc(50% - 100px);
        background-color: #ffffff !important;
        border: none;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 200px;
        height: 148px;
        cursor: pointer;
        line-height: 146px;
        vertical-align: top;
    }


</style>